(function () {
  function initGalleryShowcase(root) {
    // Hardcoded on purpose (Adrian: "ustaw po prostu w domyśle że jest 2s
    // bez możliwości zmiany na inną ilość sekund to powinno wtedy wymusić
    // wszędzie") — this used to read data-interval, sourced from a
    // per-section "Odstęp między zdjęciami" range setting. A schema
    // default only applies to a NEW instance of the section though; every
    // place this section was already placed had its own "interval": 6
    // saved in that template's JSON, which a schema-default change alone
    // never touches. Removing the setting (and the data-interval
    // attribute in the .liquid file) and hardcoding the value here
    // instead means there is no per-instance saved value left to
    // override it with — every existing and future placement of this
    // section is stuck at 2s, everywhere, with nothing left in the editor
    // to change it.
    var interval = 2000;

    // Each tile keeps its own image index (`step`) so it always resumes
    // from where it left off, but only ONE tile is allowed to advance on
    // any given beat — `active` is a round-robin cursor into `tiles`.
    // Previously every tile shared one `step` and one `render()` call, so
    // all of them swapped images in lockstep on every tick (Adrian: "nie
    // mogą zmieniać się na raz wszystkie"). Now a beat fires every 2s,
    // advances just tiles[active], then moves the cursor to the next tile,
    // wrapping back to the first once the last one has had its turn
    // ("jak dojdzie do ostatniego to znowu od początku rusza zmiana").
    var tiles = Array.from(root.querySelectorAll('[data-gallery-tile]'))
      .map(function (tile) {
        var imgs = Array.from(tile.querySelectorAll('.ladnini-gallery-showcase__img'));
        var dots = Array.from(tile.querySelectorAll('.ladnini-gallery-showcase__dot'));
        return { imgs: imgs, dots: dots, step: 0 };
      })
      .filter(function (tile) {
        return tile.imgs.length > 1;
      });
    if (!tiles.length) return;

    var active = 0;
    var timer = null;

    function renderTile(tile) {
      var index = tile.step % tile.imgs.length;
      tile.imgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      tile.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function tick() {
      var tile = tiles[active];
      tile.step += 1;
      renderTile(tile);
      active = (active + 1) % tiles.length;
    }

    function start() {
      stop();
      timer = window.setInterval(tick, interval);
    }
    function stop() {
      timer && (window.clearInterval(timer), (timer = null));
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.isIntersecting ? start() : stop();
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(root);
    } else {
      start();
    }
  }

  document.querySelectorAll('[data-gallery-showcase]').forEach(initGalleryShowcase);
})();